export default "__VITE_ASSET__dce831b5__"